import API from "@/API";
import loader from "../creators/loader";

const SET_DOCUMENT_TYPE = "SET_DOCUMENT_TYPE";
const SET_APPROVED = "SET_APPROVED";
const SET_PATHS = "SET_PATHS";
const SET_EXTERNAL_ID = "SET_EXTERNAL_ID";
const SET_CONTENT = "SET_CONTENT";
const SET_DOCUMENT_APPROVING = "SET_DOCUMENT_APPROVING";
const SET_DOCUMENT_SAVING = "SET_DOCUMENT_SAVING";
const SET_DOCUMENTS = "SET_DOCUMENTS";

const defaultState = {
  documentSavingLoader: false,
  documentApprovingLoader: false
};

export default {
  namespaced: true,

  state: {
    documents: {}
  },

  actions: {
    ...loader.actions,

    async listAllDocuments({ dispatch }, account_id) {
      try {
        var results = await API.Documents.index(account_id);
      } catch (e) {
        throw e;
      }

      dispatch("setDocuments", results.data);
    },

    async createDocument({ dispatch }, data, account_id) {
      dispatch("startLoader");

      try {
        await API.Documents.create(data, account_id);
      } catch (e) {
        throw e;
      }

      dispatch("stopLoader");
    },

    async updateDocument({ state, dispatch }, documentType) {
      dispatch("setDocumentSaving", { answer: true, documentType });

      let data = {
        paths: state.documents[documentType]["paths"],
        content: state.documents[documentType]["content"]
      };

      try {
        var results = await API.Documents.update(
          data,
          state.documents[documentType]["id"]
        );
      } catch (e) {
        return results;
      }

      dispatch("setDocumentSaving", { answer: false, documentType });

      return results;
    },

    async checkDocumentOnDataAssuranceService(
      {},
      { data_assurance_report_id, doc_external_id }
    ) {
      try {
        const response = await API.Documents.checkDocumentOnDataAssuranceService(
          data_assurance_report_id,
          doc_external_id
        );
        return response;
      } catch (error) {
        return error;
      }
    },

    async approveDocument({ state, dispatch }, documentType) {
      dispatch("setDocumentApproving", { answer: true, documentType });

      try {
        var results = await API.Documents.approveDocument(
          state.documents[documentType]["id"]
        );
      } catch (e) {
        dispatch("setDocumentApproving", { answer: false, documentType });

        return results;
      }

      dispatch("setDocumentApproving", { answer: false, documentType });

      return results;
    },

    async setDocumentReadyToProcess({ state, dispatch }, documentType) {
      dispatch("setDocumentApproving", { answer: true, documentType });

      try {
        var results = await API.Documents.setDocumentReadyToProcess(
          state.documents[documentType]["id"]
        );
      } catch (e) {
        return results;
      }

      dispatch("setDocumentApproving", { answer: false, documentType });

      return results;
    },

    async setDocumentPendingApproval({ state, dispatch }, documentType) {
      dispatch("setDocumentApproving", { answer: true, documentType });

      try {
        var results = await API.Documents.setDocumentPendingApproval(
          state.documents[documentType]["id"]
        );
      } catch (e) {
        return results;
      }

      dispatch("setDocumentApproving", { answer: false, documentType });

      return results;
    },

    async sendDocumentImage({}, payload) {
      try {
        let response = await API.Documents.sendDocumentImage(payload);
        return response;
      } catch (e) {
        throw e;
      }
    },
    setDocuments({ commit }, documents) {
      commit("SET_DOCUMENTS", documents);
    },
    setContent({ commit }, documentContent) {
      commit("SET_CONTENT", documentContent);
    },
    setPaths({ commit }, documentPaths) {
      commit("SET_PATHS", documentPaths);
    },
    setDocumentSaving({ commit }, answer) {
      commit("SET_DOCUMENT_SAVING", answer);
    },
    setDocumentApproving({ commit }, answer) {
      commit("SET_DOCUMENT_APPROVING", answer);
    }
  },
  mutations: {
    ...loader.mutations,

    [SET_APPROVED](state, answer) {
      state.approved = answer;
    },
    [SET_DOCUMENT_TYPE](state, document_type) {
      state.document_type = document_type;
    },
    [SET_PATHS](state, documentPaths) {
      state.documents[documentPaths.documentType]["paths"] =
        documentPaths.paths;
    },
    [SET_EXTERNAL_ID](state, external_id) {
      state.external_id = external_id;
    },
    [SET_CONTENT](state, documentContent) {
      state.documents[documentContent.documentType]["content"] =
        documentContent.content;
    },
    [SET_DOCUMENT_SAVING](state, answer) {
      state.documents[answer.documentType]["documentSavingLoader"] =
        answer.answer;
    },
    [SET_DOCUMENT_APPROVING](state, answer) {
      state.documents[answer.documentType]["documentApprovingLoader"] =
        answer.answer;
    },
    [SET_DOCUMENTS](state, documents) {
      state.documents = documents.reduce((newDocuments, document) => {
        return {
          ...newDocuments,
          [document.document_type]: {
            ...document,
            ...defaultState
          }
        };
      }, {});
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/documents.js